
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2.622","y":"1.055","width":"11","height":"8","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M8.046 13.578a.118.118 0 01.076-.023c.031 0 .057.005.076.017.02.012.033.032.041.059.012.027.02.054.024.082l.017.129a1.706 1.706 0 00.398.95c.196.237.438.38.727.427.078.015.196.023.352.023h2.613c.414 0 .742.1.985.299.265.215.458.516.58.902.125.391.187.764.187 1.12 0 .144-.045.214-.135.21-.039 0-.068-.011-.088-.035a.214.214 0 01-.04-.1 3.962 3.962 0 01-.024-.146l-.03-.187a2.555 2.555 0 00-.04-.2c-.223-.68-.664-1.02-1.325-1.02h-2.7c-.84 0-1.38-.476-1.618-1.429-.238.953-.754 1.43-1.547 1.43H3.91a2.97 2.97 0 00-.433.023c-.274.055-.51.205-.71.451-.199.25-.318.56-.357.926-.023.192-.074.287-.152.287-.09 0-.135-.066-.135-.199 0-.566.123-1.08.37-1.54.241-.462.595-.721 1.06-.78.078-.008.193-.012.345-.012h2.631c.266 0 .498-.055.698-.164.199-.105.345-.238.439-.398.098-.16.168-.301.211-.422.043-.117.072-.225.088-.322a1.389 1.389 0 01.017-.211.614.614 0 01.018-.082.162.162 0 01.047-.065z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":".622","y":"22.273","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    